import { render } from "./Status.vue?vue&type=template&id=49663eca&scoped=true"
const script = {}

import "./Status.vue?vue&type=style&index=0&id=49663eca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49663eca"]])

export default __exports__